import QuestionItem from '@/components/molecules/question-list/question-item';
import BlockQuestion from '@/components/molecules/question-list/question-item/block-question';
import { QnaQuestionMobileCard } from '@/types/qna';
import { QuestionSearchResultVo } from '@/types/search';
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

export interface QuestionItemProps {
  questionCard: QnaQuestionMobileCard | QuestionSearchResultVo;
  onClickQuestion: (questionId: number | string) => void;
  itemStyle?: React.CSSProperties;
}

const SearchQuestionItem: FunctionComponent<QuestionItemProps> = ({ questionCard, onClickQuestion, itemStyle }) => {
  const { questionPid, isBlockedByMe } = questionCard.question;

  return (
    <QuestionWrapper style={itemStyle}>
      <>
        {/* 내가 차단한 유저의 질문 */}
        {isBlockedByMe ? (
          <BlockQuestion />
        ) : (
          <QuestionItem
            isPaidQuestion={false}
            key={questionPid}
            questionCard={questionCard}
            onClickQuestion={() => onClickQuestion(questionPid)}
          />
        )}
      </>
    </QuestionWrapper>
  );
};

export default SearchQuestionItem;

const QuestionWrapper = styled.div`
  ${({ theme }) => `
    background: ${theme.color.white};
    `};
  & div {
    border: 0;
  }
`;
